import React, { useState, useCallback } from 'react';
import { debounce } from '../../utils/utils';
import Search from '../common/Search';

const NewsSearch = ({ onSearch }) => {
  const [inputValue, setInputValue] = useState();

  const debouncedSearch = useCallback(
    debounce((value) => {
      onSearch(value);
    }, 1000),
    [],
  );

  const handleChange = (e) => {
    setInputValue(e.target.value);
    debouncedSearch(e.target.value);
  };

  return (
    <Search
      className="news-search"
      onChange={handleChange}
      placeholder="news.tabs.search-placeholder"
      query={inputValue}
    />
  );
};

export default NewsSearch;
